$(function(){
  $(document).on('click', '#menu-drawer-overlay', function(){
    $(this).closest("#Details-menu-drawer-container").removeAttr("open");
  });
  $('.card-information__text').matchHeight();
  $('.slideNew a').matchHeight();
  $('.sliderCards__content h3').matchHeight();
  $('.pTitle, .prTitle').matchHeight();
  $('.sliderCards__content p').matchHeight();
  $('.thumbnail-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    vertical: true,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          vertical: false,
          slidesToShow: 5
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]

  });
  
  $('.thumbnail-list').slick('setPosition');
  $('.thumbnail-slider-button').click(function(){
    if($(this).hasClass('next')){
      $('.thumbnail-list').slick('slickNext');
      var current = $(this).prev().find('li [aria-current="true"]');
      current.parent().next().find('button').trigger('click');
    }
    if($(this).hasClass('prev')){
      $('.thumbnail-list').slick('slickPrev');
      var current = $(this).next().find('li [aria-current="true"]');
      current.parent().prev().find('button').trigger('click');
    }
  });
});
